import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable the browser's built-in scroll restoration once, at module load,
// so back-navigation no longer races our effect and silently re-jumps the
// user halfway down whichever page they came from. We take over manually
// via the effect below.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  try { window.history.scrollRestoration = 'manual'; } catch { /* ignore */ }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
